document.addEventListener("DOMContentLoaded", () => {
  const rippleLayer = document.querySelector(".hero-ripples")
  const heroSection = document.getElementById("hero-section")

  if (!rippleLayer || !heroSection) return

  const spawnRipple = (position = {}, options = {}) => {
    const ripple = document.createElement("span")
    ripple.className = "hero-ripple"

    const x = position.x ?? (20 + Math.random() * 60)
    const y = position.y ?? (25 + Math.random() * 55)
    const size = options.size ?? (120 + Math.random() * 140)
    const alpha = options.alpha ?? 0.45

    ripple.style.left = `${x}%`
    ripple.style.top = `${y}%`
    ripple.style.width = `${size}px`
    ripple.style.height = `${size}px`
    ripple.style.borderColor = `rgba(255, 255, 255, ${alpha})`

    rippleLayer.appendChild(ripple)

    ripple.addEventListener("animationend", () => {
      ripple.remove()
    })
  }

  spawnRipple()
  spawnRipple()

  const scheduleRipple = () => {
    spawnRipple()
    const nextDelay = 5200 + Math.random() * 3800
    setTimeout(scheduleRipple, nextDelay)
  }

  setTimeout(scheduleRipple, 3200)

  const emitRippleFromEvent = (event, options = {}) => {
    const rect = rippleLayer.getBoundingClientRect()
    const x = ((event.clientX - rect.left) / rect.width) * 100
    const y = ((event.clientY - rect.top) / rect.height) * 100
    spawnRipple(
      { x: Math.max(5, Math.min(95, x)), y: Math.max(10, Math.min(90, y)) },
      options
    )
  }

  let lastTrailTime = 0
  let lastPoint = null

  heroSection.addEventListener("mousemove", (event) => {
    const now = performance.now()
    if (now - lastTrailTime < 200) return
    lastTrailTime = now

    emitRippleFromEvent(event, { size: 80 + Math.random() * 60, alpha: 0.35 })

    if (lastPoint) {
      const rect = rippleLayer.getBoundingClientRect()
      const dx = event.clientX - lastPoint.x
      const dy = event.clientY - lastPoint.y
      const dist = Math.hypot(dx, dy)
      if (dist > 55) {
        const midX = ((lastPoint.x + event.clientX) / 2 - rect.left) / rect.width * 100
        const midY = ((lastPoint.y + event.clientY) / 2 - rect.top) / rect.height * 100
        spawnRipple(
          { x: Math.max(5, Math.min(95, midX)), y: Math.max(10, Math.min(90, midY)) },
          { size: 60 + Math.random() * 50, alpha: 0.28 }
        )
      }
    }

    lastPoint = { x: event.clientX, y: event.clientY }
  })

  heroSection.addEventListener("click", (event) => {
    emitRippleFromEvent(event, { size: 180, alpha: 0.5 })
    lastTrailTime = performance.now() + 200
  })
})
